import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Amenity from './Amenity';

const Amenities = (props) => {
  const { t } = useTranslation();
  const { slug, amenities, footer } = props;

  if (!amenities || amenities.length <= 0) {
    return null;
  }

  return (
    <Fragment>
      {footer && <h5 className='mb-3'>{t('titles.amenities')}</h5>}

      <div className="amenity-chips">
        {amenities
          .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0))
          .map((amenity, index) => {
            const amenityKey = `${slug}-amenity-${index + 1}`;

            return (
              <Amenity
                key={amenityKey}
                slug={amenityKey}
                label={amenity.label}
                icon={amenity.icon}
              />
            );
          })}
      </div>
    </Fragment>
  );
};

Amenities.propTypes = {
  slug: PropTypes.string.isRequired,
  amenities: PropTypes.array.isRequired,
  holderClasses: PropTypes.string,
  footer: PropTypes.bool,
};

export default Amenities;
